import {Athlete} from "./athlete";
import {Season} from "./season";
import {Category} from "./category";

export class Subscription {
    athlete: Athlete = new Athlete();
    athleteId: string = '';
    athletePaymentRequestId: string = '';
    category: Category = new Category();
    categoryId: string = '';
    season: Season = new Season();
    seasonId: string = '';
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    athletePaymentRequest:any

    constructor(raw?: Subscription) {

        if (raw) {
            if (raw.athlete) this.athlete = raw.athlete;
            this.athleteId = raw.athleteId;
            this.athletePaymentRequestId = raw.athletePaymentRequestId;
            if (raw.category) this.category = raw.category;
            this.categoryId = raw.categoryId;
            if (raw.season) this.season = raw.season;
            this.seasonId = raw.seasonId;
            this.status = raw.status;
            this.createdAt = raw.createdAt;
            this.updatedAt = raw.updatedAt;
            this.athletePaymentRequest = raw.athletePaymentRequest;
        }
    }
}
